import { Box, Modal, SxProps, Theme } from '@mui/material'
import { ReactNode } from 'react'

const defaultSx: SxProps<Theme> = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 2,
  width: 408,
  // Never let the modal touch the viewport edges on small screens
  maxWidth: 'calc(100vw - 32px)',
  // Keep tall modals within the viewport and allow their content to scroll
  maxHeight: 'calc(100vh - 32px)',
  overflowY: 'auto',
  borderRadius: 1,
  outline: 0,
}

type Props = {
  open: boolean
  onClose?: (event?: unknown, reason?: string) => void
  children: ReactNode
  sx?: SxProps<Theme>
}

export const SimpleModal = ({ open, onClose, children, sx }: Props) => {
  return open ? (
    <Modal open={true} onClose={onClose}>
      <Box sx={{ ...defaultSx, ...sx }}>{children}</Box>
    </Modal>
  ) : null
}
